import CatRootModulePropertiesPane from '../_CAT_ROOT_MODULE/CatRootModulePropertiesPane.jsx'

export default function PropertiesPaneCatRootAm(props) {
    return (
        <CatRootModulePropertiesPane
            {...props}
        />
    )
}
